import React from 'react';
import Style from './style.sass';

const Direction = props => {
  return (
      <div className={Style.Triangle__direction}>
        <p>向き</p>
        <table className={Style.Triangle__table}>
          <tbody>
            <tr>
              <td className={Style.Triangle__topLeft} data-direction='topLeft' data-selected={props.direction === 'topLeft'} onClick={props.onClick}></td>
              <td className={Style.Triangle__top} data-direction='top' data-selected={props.direction === 'top'} onClick={props.onClick}></td>
              <td className={Style.Triangle__topRight} data-direction='topRight' data-selected={props.direction === 'topRight'} onClick={props.onClick}></td>
            </tr>
            <tr>
              <td className={Style.Triangle__left} data-direction='left' data-selected={props.direction === 'left'} onClick={props.onClick}></td>
              <td className={Style.Triangle__center} data-direction='center' data-selected={props.direction === 'center'}></td>
              <td className={Style.Triangle__right} data-direction='right' data-selected={props.direction === 'right'} onClick={props.onClick}></td>
            </tr>
            <tr>
              <td className={Style.Triangle__bottomLeft} data-direction='bottomLeft' data-selected={props.direction === 'bottomLeft'} onClick={props.onClick}></td>
              <td className={Style.Triangle__bottom} data-direction='bottom' data-selected={props.direction === 'bottom'} onClick={props.onClick}></td>
              <td className={Style.Triangle__bottomRight} data-direction='bottomRight' data-selected={props.direction === 'bottomRight'} onClick={props.onClick}></td>
            </tr>
          </tbody>
        </table>
      </div>
  )
}
export default Direction;